<template>
	<BaseCmsPage :fetch="{slug: '/404/'}" v-slot="{page}">
		<Body class="page-error page-error-404" />
		
		<div class="main">
			<div class="wrapper page-wrapper-404">
				<h1 class="error-404-title"><BaseCmsLabel code="404_h1" default="404" /></h1>
				<div v-interpolation>
					<BaseCmsLabel code="404_description" tag="div" class="error-404-desc" />
				</div>
				<div class="error-404-links">
					<NuxtLink :to="backLink" class="btn" type="button"><BaseCmsLabel code="return_back" /></NuxtLink>
				</div>
			</div>
		</div>
	</BaseCmsPage>
</template>

<script setup>
	const {getAppUrl} = useApiRoutes();
	const router = useRouter();
	const backLink = computed(() => {
		if (router?.options?.history?.state?.back) {
			return router.options.history.state.back;
		}
		return getAppUrl('home');
	});
</script>

<style lang="less" scoped>
	.main{
		padding: 50px 0;
		:deep(p){padding-bottom: 12px;}
		@media (max-width: @t){
			padding: 30px 0;
			:deep(p){padding-bottom: 10px;}
		}
	}
</style>